import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_ALTITUD,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = null;

const altitud = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_MODIFICAR_ALTITUD: {
            const { altitud } = action;
            if (altitud === undefined || altitud === '') {
                return ESTAT_INICIAL;
            } else {
                return altitud;
            }
        }

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.altitud;

        default:
            return state;
    }
};

export default altitud;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/altitud.js